define(["jquery", "knockout", "@modules/tools/formulary-search/formularyDetailViewModel", "@modules/tools/ko.bootstrap-select", "@modules/tools/ko.bootstrapSelect.typeahead", "@modules/tools/ko.scrollTo", "@modules/tools/ko.dpOpenClose", "@plugins/knockout-multi-select/main"], function (
    $,
    ko,
    FormularyDetailViewModel
) {
    var gtmDataLayerPush = function (parameters, defaultParameters) {
        var dataLayer = window.dataLayer || [];

        var url = window.location.href.replace(/^.*\/\/[^\/]+/, "").split("?")[0];
        var jsonObject = {
            event: "gaPageview",
            eventCategory: "Pageview",
            eventAction: url,
            eventLabel: "Formulary Search"
        };

        if (parameters.formularyId) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-formulary-detail",
                eventAction: "FormularyId",
                eventLabel: parameters.formularyId
            });

            jsonObject.formularyId = parameters.formularyId;
        }
        if (parameters.formularyyear) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-formulary-detail",
                eventAction: "FormularyYear",
                eventLabel: parameters.formularyyear
            });

            jsonObject.formularyYear = parameters.formularyyear;
        }
        if (parameters.subsidyLevel) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-formulary-detail",
                eventAction: "SubsidyLevel",
                eventLabel: parameters.subsidyLevel
            });

            jsonObject.formularySubsidyLevel = parameters.subsidyLevel;
        }
        if (parameters.year) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-formulary-detail",
                eventAction: "PlanYear",
                eventLabel: parameters.year
            });
            jsonObject.formularyPlanYear = parameters.year;
        }
        if (parameters.state) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-formulary-detail",
                eventAction: "PlanState",
                eventLabel: parameters.state
            });
            jsonObject.formularyPlanState = parameters.state;
        }
        if (parameters.county) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-formulary-detail",
                eventAction: "PlanCounty",
                eventLabel: parameters.county
            });
            jsonObject.formularyPlanCounty = parameters.county;
        }
        if (parameters.plan) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Lookup-formulary-detail",
                eventAction: "PlanName",
                eventLabel: parameters.plan
            });
            jsonObject.formularyPlanName = parameters.plan;
        }

        dataLayer.push(jsonObject);
    };

    if ($("#formulary-detail").length > 0) {
        if (window.scan && window.scan.formularyDetail) {
            var formularyDetail = window.scan.formularyDetail;

            ko.applyBindings(new FormularyDetailViewModel(gtmDataLayerPush, formularyDetail.selectYearText, formularyDetail.selectStateText, formularyDetail.selectCountyText, formularyDetail.selectPlanText, formularyDetail.selectSubsidyText, formularyDetail.selectedState), $("#formulary-detail")[0]);
        }

        $(".hide-load").removeClass("hide-load");
        $(".tool-load").removeClass("tool-load");
    }

    // handle formulary email link - adding on dynamic copay params
    $("#formularyEmailLink").click(function (event) {
        event.preventDefault();
        var copayParams = "&Year=" + $("#copayYear").val() + "&State=" + $("#coPayState").val() + "&County=" + $("#coPayCounty").val() + "&Plan=" + $("#coPayPlan").val();
        copayParams = encodeURIComponent(copayParams);
        copayParams = copayParams.replace(/%20/g, '%2520');
        this.href = this.href.replace(/%7B/g, '%257B');
        this.href = this.href.replace(/%7D/g, '%257D');
        var link = this.href + copayParams;
        window.open(link);
    });

});
